import React, { PropTypes, Component } from 'react';

export default class LoginForm extends Component {
  static cid = '登录';
  static propTypes = {
    display: PropTypes.string,
    err: PropTypes.string,
    query: PropTypes.object,
    redirectCallback: PropTypes.func,
    feconfig: PropTypes.string,
    className: PropTypes.string,
    hideLoginError: PropTypes.func,
  };
  componentDidMount() {
    window.epassportCallback = this.props.redirectCallback;
  }
  componentWillReceiveProps(nextProps) {
    window.epassportCallback = nextProps.redirectCallback;
  }
  render() {
    const epassport = window.serveData.epassport || {};
    let query = Object.entries(this.props.query).reduce((result, item) => {
      result.push(item.join('='));
      return result;
    }, []).join('&');

    if (query) {
      query = `?${query}`;
    }
    const defaultClassName = `epassport-login-form login-form ${this.props.className}`;
    return (
      <div className={defaultClassName}
        style={{
          display: this.props.display,
        }}
      >
        <p className="err-tip" style={{ display: this.props.err ? '' : 'none' }}>
          <i>&times;</i>
          {this.props.err || '用户名或密码输入有误，请重新输入！'}
        </p>
        <iframe
          name="epassport"
          src={
            `${epassport.prefix}/account/unitivelogin?bg_source=4&service=dayin-pms&feconfig=${this.props.feconfig || ''}&continue=${
              encodeURIComponent(`${
                epassport.redirectUrl || document.location.origin}/pms/epassport/token${query}`
              )}&only_auth=1
            `}
        >美团商家登录平台使用了框架技术，但是您的浏览器不支持框架，请升级您的浏览器以便正常访问。</iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/epassport/index.js